import Immutable from 'immutable';
import moment from 'moment';
const LOAD = 'bgoal/LOAD';
const LOAD_SUCCESS = 'bgoal/LOAD_SUCCESS';
const LOAD_APPOINTMENTS_SUCCESS = 'bgoal/LOAD_APPOINTMENTS_SUCCESS';
const LOAD_CALENDER_SUCCESS = 'bgoal/LOAD_CALENDER_SUCCESS';
const LOAD_BCARE_SUCCESS = 'bgoal/LOAD_BCARE_SUCCESS';
const LOAD_BCARE_CALENDER_SUCCESS = 'bgoal/LOAD_BCARE_CALENDER_SUCCESS';
const LOAD_BCARE_REPORT_SUCCESS = 'bgoal/LOAD_BCARE_REPORT_SUCCESS';
const LOAD_BCARE_PRODUCTION_REPORT_SUCCESS = 'bgoal/LOAD_BCARE_PRODUCTION_REPORT_SUCCESS';
const LOAD_BUDGET_REPORT_SUCCESS = 'bgoal/LOAD_BUDGET_REPORT_SUCCESS';
const LOAD_BCARE_REPORT_TODAY_SUCCESS = 'bgoal/LOAD_BCARE_REPORT_TODAY_SUCCESS';
const LOAD_BCARE_REPORT_MONTHLY_SUCCESS = 'bgoal/LOAD_BCARE_REPORT_MONTHLY_SUCCESS';
const LOAD_BCARE_TODAY_SUCCESS = 'bgoal/LOAD_BCARE_TODAY_SUCCESS';
const LOAD_FAIL = 'bgoal/LOAD_FAIL';
const LOAD_APPOINTMENTS_FAIL = 'bgoal/LOAD_APPOINTMENTS_FAIL';
const LOAD_BCARE_FAIL = 'bgoal/LOAD_BCARE_FAIL';
const LOAD_BCARE_TODAY_FAIL = 'bgoal/LOAD_BCARE_TODAY_FAIL';
const LOAD_BCARE_REPORT_FAIL = 'bgoal/LOAD_BCARE_REPORT_FAIL';
const LOAD_BCARE_PRODUCTION_REPORT_FAIL = 'bgoal/LOAD_BCARE_PRODUCTION_REPORT_FAIL';
const LOAD_BUDGET_REPORT_FAIL = 'bgoal/LOAD_BUDGET_REPORT_FAIL';
const LOAD_BCARE_REPORT_TODAY_FAIL = 'bgoal/LOAD_BCARE_REPORT_TODAY_FAIL';
const LOAD_BCARE_REPORT_MONTHLY_FAIL = 'bgoal/LOAD_BCARE_REPORT_TODAY_FAIL';
const CLOSE_ERROR_MESSAGE = 'bgoal/CLOSE_ERROR_MESSAGE';
const LOAD_NEXT_DAYS = 'billing/LOAD_NEXT_DAYS';
const FAIL_NEXT_DAYS = 'billing/FAIL_NEXT_DAYS';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  budgetData: null,
  bcareData: null,
  bcareCalenderData: null,
  budgetCalenderData: null,
  bcareReportDetails: null,
  bcareReportDetails2: null,
  bcareTodayData: null,
  reportData: null,
  budgetReportData: null,
  reportDataToday: null,
  reportDataMonthly: null,
  appointments: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('budgetData', action.res);

    case LOAD_APPOINTMENTS_SUCCESS:
      return state
        .set('appointments', action.res);

    case LOAD_CALENDER_SUCCESS:
      return state
        .set('budgetCalenderData', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('budgetData', null);

    case LOAD_APPOINTMENTS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('appointments', null);

    case LOAD_BCARE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('bcareReportDetails', action.bcareReportDetails)
        .set('bcareData', action.res);

    case LOAD_BCARE_PRODUCTION_REPORT_SUCCESS:
      return state
        .set('isLoad', false)
        .set('bcareReportDetails2', action.res);

    case LOAD_BCARE_CALENDER_SUCCESS:
      return state
        .set('isLoad', false)
        .set('bcareCalenderData', action.res);

    case LOAD_BCARE_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('bcareData', null);

    case LOAD_BCARE_PRODUCTION_REPORT_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('bcareReportDetails2', null);

    case LOAD_BCARE_TODAY_SUCCESS:
      return state
        .set('bcareTodayData', action.res);

    case LOAD_BCARE_TODAY_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('bcareTodayData', null);

    case LOAD_BCARE_REPORT_SUCCESS:
      return state
        .set('reportData', action.res);

    case LOAD_BUDGET_REPORT_SUCCESS:
      return state
        .set('isLoad', false)
        .set('budgetReportData', action.res);

    case LOAD_BCARE_REPORT_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportData', null);

    case LOAD_BCARE_REPORT_TODAY_SUCCESS:
      return state
        .set('reportDataToday', action.res);

    case LOAD_BCARE_REPORT_TODAY_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportDataToday', null);

    case LOAD_BCARE_REPORT_MONTHLY_SUCCESS:
      return state
        .set('isLoad', false)
        .set('reportDataMonthly', action.res);

    case LOAD_BCARE_REPORT_MONTHLY_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportDataMonthly', null);

    case LOAD_NEXT_DAYS:
      return state
        .set('isLoad', false)
        .set('nextDaysData', action.res);

    case FAIL_NEXT_DAYS:
      return state
        .set('isLoad', false)
        .set('nextDaysData', null);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const copyBudgetToCalender = () => async (dispatch, getState, api) => {
  let budgetData = Object.assign({}, getState().get('bgoal').get('budgetData'));
  let bcareData = Object.assign({}, getState().get('bgoal').get('bcareData'));
  let bcareTodayData = Object.assign({}, getState().get('bgoal').get('bcareTodayData'));

  dispatch({ type: LOAD_CALENDER_SUCCESS, res: budgetData });

  if(bcareData && bcareData.orderByDate){
    if(bcareTodayData && bcareTodayData.production && Object.keys(bcareTodayData.production.orderByDate).length) {
      bcareData.orderByDate  = Object.assign({}, bcareTodayData.production.orderByDate, bcareData.orderByDate);
      bcareData.reportData  = Object.assign({}, bcareTodayData.production.reportData, bcareData.reportData);
    } else {
      const todayObject = {
        [moment().format("YYYY-MM-DD")]: {
          price: 0.00,
          provider: {},
          todayShift: (budgetData && budgetData.shifts) ? budgetData.shifts.today : 0
        }
      }
      bcareData.orderByDate  = Object.assign({}, todayObject, bcareData.orderByDate);
    }
  }
  dispatch({ type: LOAD_BCARE_CALENDER_SUCCESS, res: bcareData });
}

export const getBudgetData = (params='') => async (dispatch, getState, api) => {
  const isCalender = params.calendar;
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`bgoal/budget${params}`);
    if(isCalender) {
      dispatch({ type: LOAD_CALENDER_SUCCESS, res: res });
    } else {
        dispatch({ type: LOAD_SUCCESS, res: res });
        // dispatch({ type: LOAD_CALENDER_SUCCESS, res: res });
    }
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getAppointments = (params='') => async (dispatch, getState, api) => {
  const isCalender = params.calendar;
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`bgoal/appointments${params}`);
    if(isCalender) {
      dispatch({ type: LOAD_CALENDER_SUCCESS, res: res });
    } else {
        dispatch({ type: LOAD_APPOINTMENTS_SUCCESS, res: res });
        // dispatch({ type: LOAD_CALENDER_SUCCESS, res: res });
    }
    return res;
  } catch (err) {
    dispatch({ type: LOAD_APPOINTMENTS_FAIL, error: err.message });
  }
};

export const getAppointmentsByLocation = (params='') => async (dispatch, getState, api) => {
  const isCalender = params.calendar;
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/api/next-days-location${params}`);
    if(isCalender) {
      dispatch({ type: LOAD_NEXT_DAYS, res: res });
    } else {
      dispatch({ type: LOAD_NEXT_DAYS, res: res });
      // dispatch({ type: LOAD_CALENDER_SUCCESS, res: res });
    }
    return res;
  } catch (err) {
    dispatch({ type: FAIL_NEXT_DAYS, error: err.message });
  }
};

export const getBcareData = (params='') => async (dispatch, getState, api) => {
  const isCalender = params.calendar;
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`bgoal/bcare${params}`);
    if(isCalender) {
      dispatch({ type: LOAD_BCARE_CALENDER_SUCCESS, res: res.production });
    } else {
      dispatch({ type: LOAD_BCARE_SUCCESS, res: res.production, bcareReportDetails: res });
      dispatch(copyBudgetToCalender()); // Copy budget for current month
    }
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_FAIL, error: err.message });
  }
};

export const getBcareReportDetails2 = (params='') => async (dispatch, getState, api) => {
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`bgoal/bcareReportDetails${params}`);
    dispatch({ type: LOAD_BCARE_PRODUCTION_REPORT_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_PRODUCTION_REPORT_FAIL, error: err.message });
  }
};

export const getBcareTodayData = (params='') => async (dispatch, getState, api) => {
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`bgoal/bcare${params}`);
    dispatch({ type: LOAD_BCARE_TODAY_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_TODAY_FAIL, error: err.message });
  }
};

export const getBgoalReport = (abbr) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  const params = abbr ? '/'+abbr : '';
  try {
    let res = await api.get(`bgoal/report/budget${params}`);
    dispatch({ type: LOAD_BCARE_REPORT_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_REPORT_FAIL, error: err.message });
  }
};

export const getBudgetReport = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  params = params ? '/'+params : '';
  try {
    let res = await api.get(`bgoal/report/budgetBgoal${params}`);
    dispatch({ type: LOAD_BUDGET_REPORT_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BUDGET_REPORT_FAIL, error: err.message });
  }
};

export const getBgoalMonthlyReport = (abbr) => async (dispatch, getState, api) => {
  const params = abbr ? '/'+abbr : '';
  try {
    let res = await api.get(`bgoal/report/monthly${params}`);
    dispatch({ type: LOAD_BCARE_REPORT_MONTHLY_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_REPORT_MONTHLY_FAIL, error: err.message });
  }
};

export const getBgoalCurrentDayReport = (abbr) => async (dispatch, getState, api) => {
  const params = abbr ? '/'+abbr : '';
  try {
    let res = await api.get(`bgoal/report/currentDay${params}`);
    dispatch({ type: LOAD_BCARE_REPORT_TODAY_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BCARE_REPORT_TODAY_FAIL, error: err.message });
  }
};

export const sendReport = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post('bgoal/sendReport', {data:reportObj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
